import React from 'react'
import { Segment, Header } from 'semantic-ui-react'
import AppInboxForm from './components/form'
import firebase from '../../config/firebase'

const NewAppInbox = () => {
  const { id } = firebase.firestore().collection('app_inbox').doc()

  return (
    <div>
      <Segment color="black">
        <Header size="large">New In-App Inbox</Header>
        <AppInboxForm firebaseKey={id} action="new" />
      </Segment>
  </div>
  )
}

export default NewAppInbox


// WEBPACK FOOTER //
// ./src/containers/appInbox/new.js